import { render, staticRenderFns } from "./KaoShiTiMu.vue?vue&type=template&id=33219dec&scoped=true&"
import script from "./KaoShiTiMu.vue?vue&type=script&lang=js&"
export * from "./KaoShiTiMu.vue?vue&type=script&lang=js&"
import style0 from "./KaoShiTiMu.vue?vue&type=style&index=0&id=33219dec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33219dec",
  null
  
)

export default component.exports